import React from "react";
import withStyles from '@mui/styles/withStyles';
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import { useQuery } from "@apollo/client";
import { GET_MY_COUPON } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import { CURRENT_USER_QUERY } from "../../queries/queries";
import KyteTecMemberPurchaseModal from "./KyteTecMemberPurchaseModal";
import NotKyteTecMemeberModal from "./NotKyteTecMemeberModal";

const topOffset = "10%";
const button = {
  border: "none",
  textTransform: "uppercase",
  fontFamily: "Montserrat",
  fontSize: "12px",
  fontWeight: 600,
  borderRadius: "30px",
  padding: "10px",
  width: "100%",
  color: "white",
  backgroundColor: "#8C8C96",
};
const block = {
  padding: "0px 60px 0px 60px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const styles = (theme) => ({
  purchaseConfirmation: {
    position: "fixed",
    width: "100vw",
    top: topOffset,
    backgroundColor: "white",
    borderRadius: "15px 15px 0px 0px",
    zIndex: 100,
    boxShadow: "2px 2px 8px grey",
    maxHeight: "100vh",
    overflowY: "auto",
  },
  closeIcon: {
    position: "absolute",
    top: 18,
    right: 13,
  },
  wrapper: {
    padding: "28px 0px 0px 0px",
  },
  block: block,
  blockWithDelimiter: {
    ...block,
    borderBottom: "1px solid #70707052",
  },
  blueText: {
    color: "#238CB9",
    textAlign: "center",
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "12px",
    padding: "21px 0px",
  },
  button: button,
  buttonRed: {
    ...button,
    backgroundColor: "#D93140",
  },
  buttonWhite: {
    ...button,
    color: "#383838",
    backgroundColor: "#ffffff",
    border: "1px solid #707070",
  },
  couponCode: {
    textTransform: "uppercase",
    fontFamily: "Montserrat",
    fontWeight: 500,
    fontSize: "18px",
    padding: "8px 0px 30px 0px",
  },
});

const PurchaseConfirmationModal = ({
  classes,
  setShowPurchaseModal,
  campaignId,
  couponCode,
  setShowKyteTecRegistrationModal,
  showKyteTecRegistrationModal,
  discount
}) => {
  useMakeScrollable(".scrollable");
  const { loading, error, data } = useQuery(GET_MY_COUPON, {
    variables: { campaignId: campaignId },
    fetchPolicy: "no-cache",
  });

  const currentUser = useQuery(CURRENT_USER_QUERY, {
    fetchPolicy: "no-cache",
  });

  if (loading || currentUser.loading) return <Loading />;
  if (error || currentUser.error) return <Error />;

  const isKyteTecMember = currentUser.data.currentUser.pharmacy.kyteTecStatus;

  if (couponCode === undefined) {
    couponCode = data.myCoupons[0].id;
  }

  return (
    <div className="scrollable">
      {isKyteTecMember && (
        <KyteTecMemberPurchaseModal
          classes={classes}
          campaignId={campaignId}
          setShowPurchaseModal={setShowPurchaseModal}
          couponCode={couponCode}
          discount={discount}
        />
      )}
      {!!!isKyteTecMember && (
        <NotKyteTecMemeberModal
          setShowPurchaseModal={setShowPurchaseModal}
          setShowKyteTecRegistrationModal={setShowKyteTecRegistrationModal}
          showKyteTecRegistrationModal={showKyteTecRegistrationModal}
          currentUser={currentUser}
          couponCode={couponCode}
          discount={discount}
        />
      )}
    </div>
  );
};
export default withStyles(styles)(PurchaseConfirmationModal);
